var fn_access_inputs = function () {
    // On selects : we block action if key pressed is "enter" or "spacebar"
    $("select.form-control[aria-disabled='true']").on("keypress", function (evt) {
        if (evt.which == 32 || 8)
        {
            evt.preventDefault();
        }
    });

}
